exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item_wrap .input_wrapper[data-v-2bec1f16]{margin-left:0}.img_wrap[data-v-2bec1f16]{margin:10px 0}\n", ""]);

// exports
